import { render, staticRenderFns } from "./TaskTypeInput.vue?vue&type=template&id=37bf5caf"
import script from "./TaskTypeInput.vue?vue&type=script&lang=js"
export * from "./TaskTypeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports